"use strict";

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _taggedTemplateLiteral = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _excluded = ["handleButtonOnClick", "infos", "itemClassName"];

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var object_hash_1 = __importDefault(require("object-hash"));

var react_1 = __importStar(require("react"));

var index_1 = require("../../../index");

var TabsBarSC = styled_1.default.ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  border-bottom: 1px solid black;\n  margin-bottom: 1.5rem;\n"])));
var TabsBarItemSC = styled_1.default.li(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  margin: 0.375rem 0.75rem;\n\n  button {\n    outline: none;\n  }\n"])), function (props) {
  return props.isActive ? 600 : 400;
});
var ItemTitleSC = styled_1.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));

var TabsBar = function TabsBar(_ref) {
  var handleButtonOnClick = _ref.handleButtonOnClick,
      infos = _ref.infos,
      itemClassName = _ref.itemClassName,
      props = _objectWithoutProperties(_ref, _excluded);

  var _ref2 = (0, react_1.useContext)(index_1.FormidableContext),
      sc = _ref2.sc;

  return react_1.default.createElement(TabsBarSC, _objectSpread({
    as: sc && sc.tabsBar
  }, props), infos.map(function (info) {
    return react_1.default.createElement(TabsBarItemSC, _objectSpread({
      key: "".concat((0, object_hash_1.default)(_objectSpread({}, info))),
      as: sc && sc.tabsBarItem,
      className: "".concat(itemClassName).concat(info.isActive ? ' is-active' : '')
    }, info), react_1.default.createElement("button", {
      "data-tab": info.index,
      onClick: handleButtonOnClick,
      type: "button"
    }, react_1.default.createElement(ItemTitleSC, {
      as: sc && sc.tabsBarItemTitle
    }, info.title)));
  }));
};

exports.default = TabsBar;